module.exports = __webpack_public_path__ + "img/2.bcc936d4.png";